import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getParentMembersList = params => {
  return api.get(`admin/parent-members-list`, {
    params,
  });
};

export const getParentMembersListQueryOptions = params => {
  return queryOptions({
    queryKey: ["parent-members-list", params],
    queryFn: () => getParentMembersList(params),
  });
};

export const useParentMembersListQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getParentMembersListQueryOptions(params),
    ...queryConfig,
  });
}; 